module.exports = __webpack_public_path__ + "media/images/lb/946-15e653cd1afd81d6190641bdc1da3126.svg";